import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const baseUrl = process.env.REACT_APP_BASE_URL
const config = {
    headers: {
        "Content-Type": "application/json",
    }
}

const initialState = {
    fetchWebLoading: false,
    fetchWebSuccess: false,
    fetchWebError: false,
    fetchWebMessage: null,
    fetchWebData: null
}

export const fetchWebHomeData = createAsyncThunk("fetchWebHomeData", async (data) => {
    const url = baseUrl + data.path

    return await axios.get(url, config).then((response) => {
        return response
    }).catch((error) => { return error })
})

const WebHomeSlice = createSlice({
    name: "web",
    initialState,

    reducers: {
        resetWebState: (state) => {
            state.fetchWebLoading = false
            state.fetchWebSuccess = false
            state.fetchWebError = false
            state.fetchWebMessage = false
        }
    },

    extraReducers: (builder) => {
        builder.addCase(fetchWebHomeData.pending, (state) => {
            state.fetchWebLoading = true;
            state.fetchWebSuccess = false;
            state.fetchWebError = false;
            state.fetchWebMessage = null;
            state.fetchWebData = null;
        })
        builder.addCase(fetchWebHomeData.fulfilled, (state, action) => {
            const status = action.payload.data.status
            state.fetchWebLoading = false;
            state.fetchWebSuccess = status == true || status == "true" ? true : false;
            state.fetchWebError = status == true || status == "true" ? false : true;
            state.fetchWebMessage = status == true || status == "true" ? "Data fetched successfully." : null;
            state.fetchWebData = status == true || status == "true" ? action.payload.data.data : null;
        })
        builder.addCase(fetchWebHomeData.rejected, (state, action) => {
            state.fetchWebLoading = false;
            state.fetchWebSuccess = false;
            state.fetchWebError = true;
            state.fetchWebMessage = "Something is went wrong.";
            state.fetchWebData = null;
        })
    }
})

export const { resetWebState } = WebHomeSlice.actions;
export default WebHomeSlice.reducer;